import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Input, FormFeedback } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import debounce from 'lodash/debounce';
import { useAuth } from 'hooks/useAuth';
import { getFirebaseBackend } from 'helpers/firebaseHelper';

const isValidUrlFormat = (string) => {
  const pattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/;
  return pattern.test(string);
};

const GuidelineContainerUrlInput = ({ url, id }) => {
  const { t: translate } = useTranslation();
  const { user } = useAuth();
  const accountId = user?.account;
  const firebaseHelper = getFirebaseBackend();

  const [currentUrl, setCurrentUrl] = useState(url || '');
  const [isValid, setIsValid] = useState(true);

  const saveUrl = useCallback(
    debounce(async (newUrl) => {
      try {
        await firebaseHelper.savePublishedUrlContent(accountId, id, newUrl);
      } catch (error) {
        console.error('Error saving guideline URL:', error);
      }
    }, 500),
    [accountId, id],
  );

  const handleUrlChange = (e) => {
    const newUrl = e.target.value.trim();
    setCurrentUrl(newUrl);
    const valid = isValidUrlFormat(newUrl);
    setIsValid(valid);
    if (valid) saveUrl(newUrl);
  };

  useEffect(() => {
    return () => {
      saveUrl.cancel();
    };
  }, [saveUrl]);

  return (
    <>
      <Input
        type="text"
        value={currentUrl}
        onChange={handleUrlChange}
        placeholder={translate('Enter the publication URL')}
        invalid={!isValid && currentUrl.length > 0}
      />
      {!isValid && currentUrl.length > 0 && (
        <FormFeedback>{translate('Invalid URL!')}</FormFeedback>
      )}
    </>
  );
};

GuidelineContainerUrlInput.propTypes = {
  url: PropTypes.string,
  id: PropTypes.string.isRequired,
};

export default GuidelineContainerUrlInput;
